import React, { FunctionComponent, useContext, useEffect } from 'react'
import { BannerReferralsTableContext } from './index'
import classnames from 'classnames'
import {
  DatePicker,
  FilterBox,
  GenericInput,
  Select,
} from '../../../components'
import { has, debounce } from 'lodash'
import dateOptions from '../../../utils/dateOptions'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../../reducers'
import { LinksStore } from '../../../typings/stores/LinksStore'
import { getLinks } from '../../../actions/links'

import styles from './filters.module.css'
import { convertPeriodToDates, Period } from '../../../utils/dates'

const BannerReferralsFilter: FunctionComponent = () => {
  const dispatch = useDispatch()
  const { setFilter, setFilters, filters } = useContext(
    BannerReferralsTableContext
  )
  const products = useSelector<State, LinksStore>(state => state.links)

  const productsLoading = useSelector<State, boolean>(
    state => state.links.status === 'fetching'
  )

  useEffect(() => {
    dispatch(getLinks())
  }, [])

  const debounced = debounce(value => setFilter('subtracking', value), 300)

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <FilterBox label="Date type">
          <div className={styles.dateTypeContainer}>
            <button
              className={classnames(styles.toggleBtn, {
                [styles.selected]: filters.dateType === 'referralDate',
              })}
              onClick={() => setFilter('dateType', 'referralDate')}
            >
              Referral Date
            </button>
            <button
              className={classnames(styles.toggleBtn, {
                [styles.selected]: filters.dateType === 'saleDate',
              })}
              onClick={() => setFilter('dateType', 'saleDate')}
            >
              Sale Date
            </button>
          </div>
        </FilterBox>
        <div className={styles.dateContainer}>
          <FilterBox label="Preset date range">
            <Select
              selected={has(filters, 'dateRange') ? filters.dateRange : ''}
              options={dateOptions}
              onChange={e => {
                const dateRange = e.currentTarget.value as Period
                setFilters({ dateRange, ...convertPeriodToDates(dateRange) })
              }}
            />
          </FilterBox>
          <FilterBox label="Start date">
            <DatePicker
              value={filters.startDate}
              max={filters.endDate}
              onChange={startDate =>
                setFilters({ startDate, dateRange: 'custom' })
              }
            />
          </FilterBox>
          <FilterBox label="End date">
            <DatePicker
              value={filters.endDate}
              min={filters.startDate}
              onChange={endDate => setFilters({ endDate, dateRange: 'custom' })}
            />
          </FilterBox>
        </div>
        <FilterBox label="Filter by">
          <div className={styles.filterByContainer}>
            <Select
              className={styles.dropdown}
              placeholder="All Products"
              loadingMessage="Loading products"
              isLoading={productsLoading}
              selected={has(filters, 'product') ? filters.product : ''}
              options={products.preloaded.map(p => ({
                text: p.name,
                value: p.id,
              }))}
              onChange={e => setFilter('product', e.currentTarget.value)}
            />
            <GenericInput
              defaultValue={filters.subtracking}
              placeholder="subtracking"
              onChange={e => debounced(e.target.value)}
            />
          </div>
        </FilterBox>
      </div>
    </div>
  )
}

export default BannerReferralsFilter
